// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23wb2","footer":"styles_footer__27E3Y"};